/*!

 File: set-summary-dropdown.js
 Author: Ben Barrett
 Version: 1.0.1
 JS Dependencies:
    'closest' polyfill
    'on' helper

 CSS Dependencies:

 Description:
     Show / hide summary dropdown
*/

var setSummaryDropdown = {
    init: function () {
        console.log('setSummaryDropdown');

        var clickEvt = function(e){

            // Don't run if right-click or command/control + click
            if (e.button !== 0) return;

            var el = e.target;

            // Closest captures self as well a parents
            if (!el.closest('.js-summary-dropdown-link')) return;

            // Button clicked
            e.preventDefault();

            // Find closest dropdown block
            var elContainer = el.closest('.js-summary-item');

            if(elContainer){

                var elBlock = elContainer.querySelector('.js-summary-dropdown-content');

                if(elBlock){

                    var isOpen = elBlock.classList.contains('summary-dropdown-show');

                    //close all dropdowns
                    var elDropOpen = document.querySelectorAll('.js-summary-dropdown-content.summary-dropdown-show');
                    forEachNode(elDropOpen, function (i, el) {
                        el.classList.remove('summary-dropdown-show');
                    });
                
                    if(!isOpen){

                        elBlock.classList.add('summary-dropdown-show');

                        elBlock.offsetHeight; // force reflow
    
                        var elementPosition = elBlock.getBoundingClientRect().top;
                        var offsetPosition = elementPosition + window.pageYOffset - 50;
    
                        window.scrollTo({
                            top: offsetPosition,
                            behavior: 'smooth'
                        });

                    }                 

                }else{
                    console.log('missing .js-summary-dropdown-content element');
                }

            }else{

                console.log('missing .js-summary-item element');

            }

        }

        var closeClickEvt = function(e){

            // Don't run if right-click or command/control + click
            if (e.button !== 0) return;

            var el = e.target;

            // Closest captures self as well a parents
            if (!el.closest('.js-summary-dropdown-close')) return;

            // Button clicked
            e.preventDefault();

            // find container
            var elBlock = el.closest('.js-summary-dropdown-content');
            elBlock.classList.remove('summary-dropdown-show');

        }

        // Attach open event
        on('click', document, clickEvt);
        on('click', document, closeClickEvt);
    }
}
